__webpack_require__.p = "https://ikea.marat.qd.je/bh/ar/local-apps/alsulaiman-purchase-handler/";